module.exports = __webpack_public_path__ + "media/icons/phone@2x-197427a0.png";